import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useCreateUserGroup({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IUser) => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ userGroup }: { userGroup: Api.IUserGroup }) => {
			return userSession.webServiceHelper.callAsync<Api.IUser>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `userGroup`,
				}),
				'POST',
				userGroup
			);
		},
		onError,
		onSuccess,
	});
}
